import script from "./CompanyProductDetailView.vue?vue&type=script&setup=true&lang=js"
export * from "./CompanyProductDetailView.vue?vue&type=script&setup=true&lang=js"

import "./CompanyProductDetailView.vue?vue&type=style&index=0&id=40fb5acc&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-40fb5acc"]])

export default __exports__